import {combineReducers, createStore} from 'redux'

import {formReducer} from 'state/reducers/form'
import {viewReducer} from 'state/reducers/view'

const rootReducer = combineReducers({
	form: formReducer,
	view: viewReducer,
})

export const store = createStore(rootReducer)
